import { get, post, put, deleted } from '..';
import routes from './routes';

const CityServices = {
  createCity: async (obj) => {
    const data = await post(routes.createCity, obj);
    return data;
  },
  getCities: async (params) => {
    const data = await get(routes.getCities, params);
    return data;
  },
  getCityById: async (id) => {
    const data = await get(routes.getCityById + id);
    return data;
  },
  updateCity: async (id, obj) => {
    const data = await put(routes.updateCity + id, obj);
    return data;
  },
  deleteCity: async (id) => {
    const data = await deleted(routes.deleteCity + id);
    return data;
  },
}

export default CityServices